import { JSX } from "react";

import { Typography } from "@mui/material";
import { ConfigurationValue } from "@plansoft-configuration-renderer/configuration-api";

import { useSelectedValueDisplay } from "@/hooks/useSelectedValueDisplay";

interface DisplayTableValueComponentProps {
  selectedValue: ConfigurationValue | null;
  displayColumnName: string;
}

export function DisplayTableValueComponent({
  selectedValue,
  displayColumnName,
}: DisplayTableValueComponentProps): JSX.Element {
  const { displayValue } = useSelectedValueDisplay(
    selectedValue,
    displayColumnName,
  );

  return (
    <Typography color={"primary"} sx={{ fontWeight: "bold" }}>
      {String(displayValue ?? "")}
    </Typography>
  );
}
